import React from 'react';

import { flagStyles } from '../settings';

const SvgBA = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-360px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgBA;
